// client/src/utils/push.js — Maxula
// Web Push : support, etat, abonnement / desabonnement (utilise l'instance API).
import API from '../services/api';

export function isPushSupported() {
  return typeof navigator !== 'undefined'
    && 'serviceWorker' in navigator
    && typeof window !== 'undefined'
    && 'PushManager' in window
    && 'Notification' in window;
}

function urlBase64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = window.atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
}

export async function getPushState() {
  if (!isPushSupported()) return { supported: false, subscribed: false, permission: 'unsupported' };
  let subscribed = false;
  try {
    const reg = await navigator.serviceWorker.ready;
    const sub = await reg.pushManager.getSubscription();
    subscribed = !!sub;
  } catch (e) { /* ignore */ }
  return { supported: true, subscribed, permission: Notification.permission };
}

export async function subscribePush() {
  if (!isPushSupported()) throw new Error('Notifications non supportées par ce navigateur.');
  const { data } = await API.get('/push/public-key');
  if (!data || !data.enabled || !data.publicKey) {
    throw new Error('Les notifications ne sont pas encore configurées côté serveur.');
  }
  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permission refusée pour les notifications.');
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.publicKey)
    });
  }
  await API.post('/push/subscribe', { subscription: sub.toJSON ? sub.toJSON() : sub });
  return true;
}

export async function unsubscribePush() {
  if (!isPushSupported()) return true;
  const reg = await navigator.serviceWorker.ready;
  const sub = await reg.pushManager.getSubscription();
  if (sub) {
    const endpoint = sub.endpoint;
    try { await sub.unsubscribe(); } catch (e) { /* ignore */ }
    try { await API.post('/push/unsubscribe', { endpoint }); } catch (e) { /* ignore */ }
  }
  return true;
}
